/* ════════════════════════════════════════════════════════════
   PlayShop - Deck Hub frontend
   Fetch decks (curated meta + ready-to-buy + mine si customer)
   depuis Supabase Edge function `deck-list`.
   Cartes deck enrichies (score + complétude + compo + prix) + tri.
   Validé Lorenzo 2026-05-28.
   ════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  var hub = document.querySelector('.ps-deck-hub');
  if (!hub) return;

  var customerId = hub.dataset.psCustomerId || null;
  var SUPABASE_FN_URL = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/deck-list';
  var SUPABASE_FN_BASE = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1';

  var FORMAT_LABELS = {
    standard: 'Standard', etendu: 'Étendu', illimite: 'Illimité', theme: 'Théma', glc: 'GLC'
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatPrice(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(v);
    if (isNaN(n)) return null;
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  /**
   * Score de préparation 0-100. Si le builder a déjà persisté playshop_score, on l'utilise ;
   * sinon on calcule un score de complétude depuis les compteurs (complétude vers 60 + équilibre des familles).
   * Retourne null pour un deck vide (0 carte).
   */
  function deckScore(deck) {
    if (deck.playshop_score != null) return deck.playshop_score;
    var cc = deck.card_count || 0;
    if (cc === 0) return null;
    var completeness = Math.max(0, Math.round(60 * (1 - Math.abs(60 - cc) / 60)));
    var pk = deck.pokemon_count || 0, tr = deck.trainer_count || 0, en = deck.energy_count || 0;
    var comp = 0;
    comp += pk >= 4 ? 14 : Math.round(pk / 4 * 14);
    comp += tr >= 10 ? 16 : Math.round(tr / 10 * 16);
    comp += en >= 3 ? 10 : Math.round(en / 3 * 10);
    return Math.max(0, Math.min(100, completeness + comp));
  }

  function scoreColor(s) {
    if (s >= 80) return '#22c55e';
    if (s >= 65) return '#84cc16';
    if (s >= 50) return '#eab308';
    if (s >= 35) return '#f97316';
    return '#ef4444';
  }

  /**
   * Fetch decks par catégorie depuis Edge function.
   */
  function fetchDecks(category) {
    // Pas de limite pratique : le client voit TOUS ses decks sur la même page.
    // game=pokemon : ce hub est /pages/decks (Pokémon). Filtre indispensable, sinon les decks
    // Lorcana de l'user remontent dans la bibliothèque Pokémon (bug fix 2026-05-31).
    var params = new URLSearchParams({ category: category, game: 'pokemon', limit: '500' });
    if (customerId && category === 'mine') params.set('customer_id', customerId);
    return fetch(SUPABASE_FN_URL + '?' + params.toString(), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'x-ps-token': window.PS_AUTH_TOKEN || '' }
    }).then(function(r) {
      if (!r.ok) throw new Error('Edge function not yet deployed');
      return r.json();
    }).catch(function() {
      return { decks: [] };
    });
  }

  function deleteBtnHTML(deck) {
    return '<button type="button" class="ps-deck-hub__card-delete" aria-label="Supprimer ce deck" title="Supprimer ce deck"' +
      ' data-deck-slug="' + esc(deck.slug || '') + '"' +
      ' data-deck-name="' + esc(deck.name || 'Deck') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
      '</button>';
  }

  /**
   * Carte deck enrichie : visuel + score + format + complétude + compo + prix.
   */
  function renderDeckCard(deck, deletable) {
    var li = document.createElement('li');
    li.className = 'ps-deck-hub__card';

    var cc = deck.card_count || 0;
    var complete = cc >= 60;
    var pct = Math.min(100, Math.round((cc / 60) * 100));
    var score = deckScore(deck);
    var fmt = FORMAT_LABELS[deck.format] || (deck.format || '');
    var price = formatPrice(deck.total_price_eur);

    var thumbHTML = deck.thumbnail_url
      ? '<img src="' + esc(deck.thumbnail_url) + '" alt="' + esc(deck.name || '') + '" loading="lazy" />'
      : '<span class="ps-deck-hub__card-thumb-empty" aria-hidden="true">🃏</span>';

    var scoreBadge = (score != null)
      ? '<span class="ps-deck-hub__score" style="--score-color:' + scoreColor(score) + '" title="Score de préparation du deck">' +
          '<strong>' + score + '</strong><small>/100</small></span>'
      : '';

    // Tier curé (meta/tier1…) sinon format
    var tier = '';
    if (deck.curated_tier === 'meta') tier = 'Meta';
    else if (deck.curated_tier === 'tier1') tier = 'Tier 1';
    else if (deck.curated_tier === 'tier2') tier = 'Tier 2';
    else if (deck.curated_tier === 'budget') tier = 'Budget';
    var topRight = tier
      ? '<span class="ps-deck-hub__fmt ps-deck-hub__fmt--tier">' + tier + '</span>'
      : (fmt ? '<span class="ps-deck-hub__fmt">' + esc(fmt) + '</span>' : '');

    var compo = (cc > 0)
      ? '<div class="ps-deck-hub__compo">' +
          '<span title="Pokémon">🔵 ' + (deck.pokemon_count || 0) + '</span>' +
          '<span title="Dresseur">🟡 ' + (deck.trainer_count || 0) + '</span>' +
          '<span title="Énergie">⚡ ' + (deck.energy_count || 0) + '</span>' +
        '</div>'
      : '';

    var countRow = '<div class="ps-deck-hub__count' + (complete ? ' is-complete' : '') + '">' +
        '<div class="ps-deck-hub__count-bar"><span style="width:' + pct + '%"></span></div>' +
        '<span class="ps-deck-hub__count-label">' + cc + '/60' + (complete ? ' ✓' : '') + '</span>' +
      '</div>';

    var priceRow = price
      ? '<div class="ps-deck-hub__price">' + price + '</div>'
      : '<div class="ps-deck-hub__price ps-deck-hub__price--empty">Deck vide</div>';

    li.innerHTML =
      '<a href="/pages/decks-pokemon?deck=' + esc(deck.slug) + '" class="ps-deck-hub__card-link">' +
        '<div class="ps-deck-hub__card-thumb">' + thumbHTML + scoreBadge + topRight + '</div>' +
        '<div class="ps-deck-hub__card-body">' +
          '<span class="ps-deck-hub__card-title">' + esc(deck.name || 'Deck') + '</span>' +
          countRow +
          compo +
          priceRow +
        '</div>' +
      '</a>' +
      (deletable ? deleteBtnHTML(deck) : '');

    return li;
  }

  function renderCreateCard() {
    var li = document.createElement('li');
    li.className = 'ps-deck-hub__card ps-deck-hub__card--create';
    li.innerHTML =
      '<a href="/pages/decks-pokemon#construire" data-ps-deck-tab="build" class="ps-deck-hub__card-link">' +
        '<span class="ps-deck-hub__card-create-icon" aria-hidden="true">+</span>' +
        '<span class="ps-deck-hub__card-create-label">Nouveau Deck</span>' +
      '</a>';
    return li;
  }

  /**
   * Empty states personnalisés par catégorie.
   */
  var EMPTY_STATES = {
    meta: {
      icon: '🏆',
      title: 'Decks meta en cours de curation',
      text: 'Notre équipe analyse les derniers Régionaux pour te proposer les meilleurs decks Tier 1. Reviens bientôt !',
      ctaLabel: 'Découvrir les sets',
      ctaUrl: '/pages/tcg-pokemon'
    },
    ready: {
      icon: '📦',
      title: 'Decks prêts à acheter en préparation',
      text: 'Nous assemblons des decks complets 100% en stock pour débuter ou progresser. Les premiers arrivent très vite !',
      ctaLabel: 'Construire le mien',
      ctaUrl: '/pages/decks-pokemon#construire'
    },
    mine: {
      icon: '🛠',
      title: 'Crée ton premier deck',
      text: 'Tu n\'as pas encore créé de deck. Lance-toi avec notre builder gratuit, c\'est fait pour les débutants comme pour les confirmés.',
      ctaLabel: '+ Nouveau deck',
      ctaUrl: '/pages/decks-pokemon#construire'
    }
  };

  function emptyStateLI(category) {
    var s = EMPTY_STATES[category] || EMPTY_STATES.mine;
    var li = document.createElement('li');
    li.className = 'ps-deck-hub__empty';
    li.innerHTML =
      '<span class="ps-deck-hub__empty-icon" aria-hidden="true">' + s.icon + '</span>' +
      '<strong class="ps-deck-hub__empty-title">' + s.title + '</strong>' +
      '<p class="ps-deck-hub__empty-text">' + s.text + '</p>' +
      '<a href="' + s.ctaUrl + '" class="ps-btn ps-btn--ghost ps-btn--sm">' + s.ctaLabel + '</a>';
    return li;
  }

  /**
   * Remplit une grille. Pour « mine » : carte « Nouveau deck » toujours en tête, puis les decks.
   */
  function populateGrid(grid, decks, category) {
    grid.setAttribute('aria-busy', 'false');
    grid.innerHTML = '';

    if (category === 'mine') {
      grid.appendChild(renderCreateCard());
      (decks || []).forEach(function(deck) { grid.appendChild(renderDeckCard(deck, true)); });
      return;
    }

    if (!decks || decks.length === 0) {
      grid.appendChild(emptyStateLI(category));
      return;
    }
    decks.forEach(function(deck) { grid.appendChild(renderDeckCard(deck, false)); });
  }

  /**
   * Tri des decks (catégorie « mine »).
   */
  function sortDecks(decks, mode) {
    var arr = decks.slice();
    if (mode === 'score') {
      arr.sort(function(a, b) { return (deckScore(b) == null ? -1 : deckScore(b)) - (deckScore(a) == null ? -1 : deckScore(a)); });
    } else if (mode === 'price-desc') {
      arr.sort(function(a, b) { return (parseFloat(b.total_price_eur) || 0) - (parseFloat(a.total_price_eur) || 0); });
    } else if (mode === 'price-asc') {
      arr.sort(function(a, b) { return (parseFloat(a.total_price_eur) || 0) - (parseFloat(b.total_price_eur) || 0); });
    } else if (mode === 'cards') {
      arr.sort(function(a, b) { return (b.card_count || 0) - (a.card_count || 0); });
    }
    // 'recent' = ordre serveur (updated_at desc) → inchangé
    return arr;
  }

  // Liste courante des decks « mine » (source unique pour tri + suppression).
  var _mineDecks = [];

  function updateLibCount() {
    var countEl = document.querySelector('[data-ps-libcount]');
    if (!countEl) return;
    var n = _mineDecks.length;
    countEl.textContent = n + ' deck' + (n > 1 ? 's' : '');
  }

  /**
   * Barre d'en-tête Bibliothèque (rendue côté serveur dans le liquid) :
   * compteur (gauche) · titre (centre) · tri (droite). JS ne fait que remplir + brancher.
   */
  function setupMineTools(grid) {
    updateLibCount();
    var sel = document.querySelector('[data-ps-deck-sort]');
    if (sel && !sel._psWired) {
      sel._psWired = true;
      sel.addEventListener('change', function() {
        populateGrid(grid, sortDecks(_mineDecks, sel.value), 'mine');
      });
    }
  }

  // 🆕 Suppression d'un deck depuis « Ma Bibliothèque » : toast Oui/Non.
  function confirmToast(message, onYes) {
    var prev = document.querySelector('.ps-deck-toast');
    if (prev) prev.remove();
    var t = document.createElement('div');
    t.className = 'ps-deck-toast';
    t.innerHTML = '<div class="ps-deck-toast__box" role="alertdialog" aria-modal="true" aria-label="Confirmation">' +
        '<p class="ps-deck-toast__msg">' + message + '</p>' +
        '<div class="ps-deck-toast__actions">' +
          '<button type="button" class="ps-deck-toast__btn ps-deck-toast__btn--yes">Oui</button>' +
          '<button type="button" class="ps-deck-toast__btn ps-deck-toast__btn--no">Non</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(t);
    function close() { t.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    t.addEventListener('click', function(e) { if (e.target === t) close(); });
    t.querySelector('.ps-deck-toast__btn--no').addEventListener('click', close);
    t.querySelector('.ps-deck-toast__btn--yes').addEventListener('click', function() { close(); onYes(); });
  }

  // Délégation : clic sur une poubelle → confirmation → deck-delete → retire la carte.
  hub.addEventListener('click', function(e) {
    var btn = e.target.closest('.ps-deck-hub__card-delete');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var slug = btn.getAttribute('data-deck-slug');
    if (!slug) return;
    var name = (btn.getAttribute('data-deck-name') || 'ce deck')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    confirmToast('Voulez-vous vraiment supprimer « ' + name + ' » ?', function() {
      btn.disabled = true;
      fetch(SUPABASE_FN_BASE + '/deck-delete', {
        method: 'POST',
        // `customer_id` est usurpable : le contrôle « ce deck est-il à toi ? » comparait
        // l'identité usurpée à elle-même, donc passait toujours ⇒ n'importe qui pouvait
        // supprimer les decks d'un autre. L'identité vient désormais du jeton.
        headers: { 'Content-Type': 'application/json', 'x-ps-token': window.PS_AUTH_TOKEN || '' },
        body: JSON.stringify({ slug: slug, customer_id: customerId })
      })
        .then(function(r) { return r.json(); })
        .then(function(res) {
          if (res && res.success) {
            var li = btn.closest('.ps-deck-hub__card');
            if (li) li.remove();
            // Retire de la source + MAJ compteur
            _mineDecks = _mineDecks.filter(function(d) { return d.slug !== slug; });
            updateLibCount();
          } else { btn.disabled = false; }
        })
        .catch(function() { btn.disabled = false; });
    });
  });

  // Lance les fetchs en parallèle
  ['meta', 'ready', 'mine'].forEach(function(cat) {
    var grid = hub.querySelector('[data-ps-deck-grid="' + cat + '"]');
    if (!grid) return;
    if (cat === 'mine' && !customerId) return;

    fetchDecks(cat).then(function(res) {
      var decks = res.decks || [];
      if (cat === 'mine') {
        _mineDecks = decks;
        setupMineTools(grid);
        populateGrid(grid, sortDecks(_mineDecks, 'recent'), 'mine');
      } else {
        populateGrid(grid, decks, cat);
      }
    });
  });

})();
